module.exports = __webpack_public_path__ + "img/pmi_chapter_mauritius_logo-inverted.2b735d82.png";